<template>
  <div class="h-100">
    <Navbar/>
    <div class="colmn">
      <SideMenu/>
      <div class="home-main-wrapper">
        <div class="main">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/globals/Header.vue';
import SideMenu from '@/components/globals/Sidebar.vue';

export default {
  name: 'home',
  components: {
    Navbar,
    SideMenu,
  },
};
</script>

<style scoped>
.home-main-wrapper {
  margin-left:170px;
  width: 100%;
}

.colmn {
  margin-top:3rem;
  height: 100%;
  width: 100%;
  display: flex;
}

.main {
  max-width: 1000px;
  margin:0 auto;
  width: 80%;
  padding: 20px;
}
</style>
